export function extractCriterionDescription(rawValue) {
  if (rawValue === null || rawValue === undefined) {
    return "";
  }

  const value = String(rawValue).trim();
  if (!value) {
    return value;
  }

  const firstSeparatorIndex = value.search(/[-–—]/);
  if (firstSeparatorIndex < 0) {
    return value;
  }

  const suffix = value.slice(firstSeparatorIndex + 1).trim();
  if (!suffix) {
    return value;
  }

  const cleanedSuffix = suffix.replace(/^[\s\d.]+[-–—\s]*/, "").trim();
  return cleanedSuffix || suffix || value;
}

export function buildCriterionDisplayLabel(rawValue) {
  if (rawValue === null || rawValue === undefined) {
    return "";
  }

  const value = String(rawValue).trim();
  if (!value) {
    return value;
  }

  const description = extractCriterionDescription(value);
  return description || value;
}
